import StoreApi from "../api/service/store/StoreApi";
import { useNavigate } from "react-router-dom";

export default class StoreService {
    api;

    constructor() {
        this.api = new StoreApi();
    }

    navigate = useNavigate();

    async getStoreDetail({ storeId }) {
        return this.api.getStoreDetail({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreList({ page, pageSize, shopCode, shopName, phoneNumber, address, states }) {
        return this.api
            .getStoreList({ page, pageSize, shopCode, shopName, phoneNumber, address, states })
            .then(async (res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async getStoresImages({ stores }) {
        stores = await Promise.all(
            stores.map(async (store) => {
                try {
                    const images = await this.api.getStoreImages({ storeId: store.storeId });

                    // 새로운 객체를 반환하여 데이터 무결성 유지
                    return {
                        ...store,
                        thumbnail: images.result.images[0]?.url ?? undefined,
                    };
                } catch (error) {
                    console.error("이미지 로드 실패:", error);
                    return store; // 에러 발생 시 원래 정보라도 유지
                }
            })
        );

        console.log("stores: ", stores);

        return stores;
    }

    async getStoreImages({ storeId }) {
        return await this.api.getStoreImages({ storeId: storeId });
    }

    async getStoreAdminList({ page, pageSize, franchisesCode }) {
        return this.api
            .getStoreAdminList({ page, pageSize, franchisesCode })
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async saveStore(reqDto, images) {
        return this.api
            .saveStore(reqDto)
            .then((res) => {
                if (res.resultCode === "0000") {
                    console.log("res.result.storeId: ", res.result.storeId);

                    images.map((image) => {
                        this.api.saveStoreImage({ storeId: res.result.storeId, image: image });
                    });

                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data);
                throw err.response.data;
            });
    }

    async updateStore(reqDto) {
        return this.api.updateStore(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteStore({ storeId }) {
        return this.api.deleteStore({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreReportDetail({ storeId, period, startDate, endDate }) {
        return this.api.getStoreReportDetail({ storeId, period, startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreDeviceStatus({ storeId }) {
        return this.api.getStoreDeviceStatus({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreDeviceStatusSummary({ storeId }) {
        return this.api.getStoreDeviceStatusSummary({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreRecentRevenue({ storeId, startDate, endDate }) {
        return this.api.getStoreRecentRevenue({ storeId, startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreRevenueSummary({ today }) {
        return this.api.getStoreRevenueSummary({ today }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreRevenueSummaryByStore({ storeId, today }) {
        return this.api.getStoreRevenueSummaryByStore({ storeId, today }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreRevenueByStore({ storeId, periodType, startDate, endDate }) {
        return this.api.getStoreRevenueByStore({ storeId, periodType, startDate, endDate }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getStoreQrCode({ storeId }) {
        return this.api.getStoreQrCode({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getGpsStoreList({ radius, userLatitude, userLongitude, pageSize = 15 }) {
        console.log("1: ", radius, userLatitude, userLongitude, pageSize);
        return this.api
            .getGpsStoreList({
                radius: String(radius),
                userLatitude: userLatitude.toFixed(7),
                userLongitude: userLongitude.toFixed(7),
                pageSize,
            })
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async syncShopCode() {
        return this.api
            .syncShopCode()
            .then((res) => {
                if (res.resultCode === "0000") {
                    return res.result;
                } else {
                    throw new Error(res.result);
                }
            })
            .catch((err) => {
                console.log("err: ", err.response.data.resultCode);
                if (err.response.data.resultCode === "0102") {
                    this.navigate("/auth");
                }
            });
    }

    async getStoreDevice({ storeId }) {
        return this.api.getStoreDevice({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceMemo({ deviceId }) {
        return this.api.getDeviceMemo({ deviceId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async createDeviceMemo({ deviceId, memo }) {
        return this.api.createDeviceMemo({ deviceId, memo }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateDeviceMemo({ deviceId, memoId, memo }) {
        return this.api.updateDeviceMemo({ deviceId, memoId, memo }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteDeviceMemo({ deviceId, memoId }) {
        return this.api.deleteDeviceMemo({ deviceId, memoId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
